/** Магазины — служба Cashiers (RP-GK1): настройка магазинов и их статистика продаж. */
const ROOT = '/api/cashiers/v1/sales-points'
export const SALES_POINT_URLS = {
  root: ROOT,
  registers: (resourceId: string) => `${ROOT}/sources/${encodeURIComponent(resourceId)}/registers`,
  audit: (id: string) => `${ROOT}/${encodeURIComponent(id)}/audit`,
  summary: (id: string) => `${ROOT}/${encodeURIComponent(id)}/summary`,
  cashiers: (id: string) => `${ROOT}/${encodeURIComponent(id)}/cashiers`,
  receipts: (id: string) => `${ROOT}/${encodeURIComponent(id)}/receipts`,
} as const
